import { render, staticRenderFns } from "./Team.vue?vue&type=template&id=4c23bd12&scoped=true&"
import script from "./Team.vue?vue&type=script&lang=js&"
export * from "./Team.vue?vue&type=script&lang=js&"
import style0 from "./Team.vue?vue&type=style&index=0&id=4c23bd12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c23bd12",
  null
  
)

export default component.exports